export default __webpack_public_path__ + "static/logo-9831bd1d8e5d1c701cac01f88da96d70.svg";